<template>
  <v-app>
    <v-main>
    <div class="main-container"></div>
      <router-view class="router-view"/>
      <Snackbar />
      <!-- <Loader />       -->
    </v-main>
  </v-app>
</template>

<script>
import Snackbar from './components/SnackbarAlert.vue';
// import SvgBackground from './assets/svgBackground.svg';
// import Loader from './components/Loader.vue';

export default {
  name: 'App',

  components: {
    Snackbar,
    // Loader,
  },
};
</script>

<style>
html { 
  overflow-y: auto !important;
}

.main-container {
  position: fixed;
  width: 100%;
  height: 100%;
  transform: rotate(-10deg) scale(1.3);
  opacity: 0.1;
  background-image: url('@/assets/svgBackground.svg');
  background-repeat: repeat repeat;
}
</style>
